/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.17.3
 * @since 1.0.1
 */
import { ChartPie } from '../../../../../../components/common';
import { widgetCostsConfiguration } from '../constant/widgetCostsConstants';

interface IWidgetCostsChartEmptyProps {
    currency: string;
    isLegendDisable?: boolean;
    isTooltipDisable?: boolean;
    isTotalDisable?: boolean;
    total?: number;
}

const WidgetCostsChartEmpty = (props: IWidgetCostsChartEmptyProps) =>
    <ChartPie
        {...props}
        isEmpty
        currency={props.currency}
        data={widgetCostsConfiguration.chartEmpty.data}
        innerRadius={widgetCostsConfiguration.chart.innerRadius}
        legendSize={widgetCostsConfiguration.chart.legendSize}
        padding={widgetCostsConfiguration.chart.padding}
        radius={widgetCostsConfiguration.chart.radius}
        size={widgetCostsConfiguration.chart.size}
        strokeColor={widgetCostsConfiguration.chart.strokeColor}
    />;

export default WidgetCostsChartEmpty;
